import { render, staticRenderFns } from "./InstallCommandModal.vue?vue&type=template&id=2e8d74cf&scoped=true"
import script from "./InstallCommandModal.vue?vue&type=script&lang=js"
export * from "./InstallCommandModal.vue?vue&type=script&lang=js"
import style0 from "./InstallCommandModal.vue?vue&type=style&index=0&id=2e8d74cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d74cf",
  null
  
)

export default component.exports